import { defineComponent as _defineComponent } from 'vue'
import { StickySidebar } from 'ui-shared-components'
// MIGRATION-TODO: This will be removed when migrating when this is moved to an organism


export default /*#__PURE__*/_defineComponent({
  __name: 'receipt-wrapper',
  setup(__props) {

// eslint-disable-next-line @nx/enforce-module-boundaries

return { __sfc: true,StickySidebar }
}

})